'use client';

export default function PcFooter() {
    return <></>;
}
